import { createUseStyles } from 'react-jss';
import { interactive } from '../../utils/theme';

export default createUseStyles({
  point: {
    width: 10,
    height: 10,
    background: interactive.cerulean50,
    borderRadius: '50%',
  },
  line: {
    position: 'absolute',
    '&.left': {
      left: '-50px',
    },
    '&.right': {
      right: '-50px',
    },
    '&> div.line': {
      width: 40,
      height: 3,
      background: interactive.cerulean50,
    },
  },
  container: {
    '& .ant-timeline-item-tail': {
      background: interactive.cerulean50,
      borderWidth: 3,

      '@media (max-width: 767px)': {
        left: '12px',
      },
    },
    '@media (min-width: 768px)': {
      marginTop: '76px',
      '& .ant-timeline-item': {
        minHeight: 218,
        '& .ant-timeline-item-head': {
          padding: 0,
          borderRadius: 100,
          '@media (max-width: 767px)': {
            left: '12px',
          },
        },
        '&.ant-timeline-item-left': {
          '& .ant-timeline-item-content': {
            width: 'calc(50% - 140px)',
            'margin-inline-start': 140,
          },
          '& .ant-timeline-item-label': {
            transform: 'translate(70px, -62px)',
          },
        },
        '&.ant-timeline-item-right': {
          '& .ant-timeline-item-content': {
            width: 'calc(50% - 140px)',
          },
          '& .ant-timeline-item-label': {
            transform: 'translate(-70px, -62px)',
          },
        },
        '& .ant-timeline-item-label': {
          textAlign: 'center !important',
        },
      },
    },
    '@media (max-width: 767px)': {
      '& .ant-timeline-item-label': {
        color: interactive.cerulean50,
        lineHeight: '20px',
        fontSize: 12.8,
        marginLeft: 24,
        'inset-inline-start': '30% !important',
        width: '100%',
      },
      '& .ant-timeline-item-head': {
        padding: 0,
        'inset-inline-start': '30% !important',
        width: 28,
      },
      '& .ant-timeline-item-tail': {
        'inset-inline-start': '30% !important',
      },
      '& .ant-timeline-item-content': {
        width: '100% !important',
        '& span': {
          textAlign: 'left',
        },
      },
    },
  },
});
